import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61dd2304")

_pushScopeId("data-v-61dd2304")
const _hoisted_1 = { class: "base-team-card" }
const _hoisted_2 = { class: "base-team-card__content" }
const _hoisted_3 = {
  key: 0,
  class: "base-team-card__team"
}
const _hoisted_4 = { class: "base-team-card__team-item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "J", -1)
const _hoisted_6 = { class: "base-team-card__team-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "M", -1)
const _hoisted_8 = { class: "base-team-card__team-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "S", -1)
const _hoisted_10 = { class: "base-team-card__team-item" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "L", -1)
const _hoisted_12 = {
  key: 1,
  class: "base-team-card__price"
}
const _hoisted_13 = {
  key: 2,
  class: "base-team-card__price"
}
const _hoisted_14 = {
  key: 3,
  class: "base-team-card__payments"
}
const _hoisted_15 = { class: "base-team-card__payments--junior" }
const _hoisted_16 = { class: "base-team-card__payments--mid" }
const _hoisted_17 = { class: "base-team-card__payments--senior" }
const _hoisted_18 = { class: "base-team-card__payments--lead" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "base-team-card__header",
      style: { backgroundColor: _ctx.color }
    }, null, 4),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "base-team-card__title",
        style: _ctx.title.length > 11 && { fontSize: '1.4em', lineHeight: '1.2em' }
      }, _toDisplayString(_ctx.title), 5),
      (!_ctx.big && _ctx.owner && _ctx.owner.name)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryOne), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryTwo), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryThree), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryFour), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.owner && _ctx.owner.name && _ctx.charge)
        ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('boardCard.pay')) + " " + _toDisplayString(_ctx.charge), 1))
        : _createCommentVNode("", true),
      (!_ctx.owner || !_ctx.owner.name)
        ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('boardCard.buy')) + " " + _toDisplayString(_ctx.price), 1))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ["base-team-card__owner", { owned: _ctx.owner && _ctx.owner.name }]
      }, _toDisplayString(_ctx.owner && _ctx.owner.name ? _ctx.owner.name : _ctx.$t('boardCard.notOwned')), 3),
      (_ctx.big)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("span", null, _toDisplayString(_ctx.upgradeConfig.categoryOne[_ctx.$i18n.locale]), 1),
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryOne), 1)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("span", null, _toDisplayString(_ctx.upgradeConfig.categoryTwo[_ctx.$i18n.locale]), 1),
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryTwo), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("span", null, _toDisplayString(_ctx.upgradeConfig.categoryThree[_ctx.$i18n.locale]), 1),
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryThree), 1)
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("span", null, _toDisplayString(_ctx.upgradeConfig.categoryFour[_ctx.$i18n.locale]), 1),
              _createVNode("span", null, _toDisplayString(_ctx.team.categoryFour), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})